module.exports = __webpack_public_path__ + "static/img/7.94f45a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/zh/7.png
// module id = CaFN
// module chunks = 0